import React from 'react'
import PropTypes from 'prop-types'
import { SanitizeHTML } from '@tc-packages/tc-common'
import Button from './shared/Button'

// TitleSection: A component that displays a centered title.
export default function TitleSection({ section }) {
  const {
    body,
    button_arrow,
    button_background,
    button_background_hover,
    button_color,
    button_color_hover,
    button_label,
    button_url,
    config: { is_gray, is_left_aligned, title_with_button },
    link_open_in_new_tab,
    node_id,
    subtitle,
    title,
  } = section

  const baseClass = is_left_aligned ? 'sectionTitle' : 'sectionTitle--centered'

  return (
    <section
      className={`sectionTitle ${is_gray ? ' section--grey' : ''}`}
      key={node_id}
    >
      <div className={baseClass}>
        <div className={`${baseClass}_container container`}>
          <div
            className={`${baseClass}_contentWrapper contentWrapper_large mb-0`}
          >
            {title && <h2 className={`${baseClass}_title`}>{title}</h2>}
            {subtitle && (
              <h3 className={`${baseClass}_subtitle`}>{subtitle}</h3>
            )}
            {body && (
              <div className={`${baseClass}_subline`}>
                <SanitizeHTML html={body} />
              </div>
            )}
            {title_with_button && (
              <Button
                arrow={button_arrow}
                background={button_background}
                backgroundHover={button_background_hover}
                color={button_color}
                colorHover={button_color_hover}
                label={button_label}
                openInNewTab={link_open_in_new_tab}
                url={button_url}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

TitleSection.propTypes = {
  section: PropTypes.shape({
    body: PropTypes.string.isRequired,
    button_arrow: PropTypes.string.isRequired,
    button_background: PropTypes.string.isRequired,
    button_background_hover: PropTypes.string.isRequired,
    button_color: PropTypes.string.isRequired,
    button_color_hover: PropTypes.string.isRequired,
    button_label: PropTypes.string.isRequired,
    button_url: PropTypes.string.isRequired,
    config: PropTypes.shape({
      is_gray: PropTypes.bool.isRequired,
      is_left_aligned: PropTypes.bool.isRequired,
      title_with_button: PropTypes.bool.isRequired,
    }).isRequired,
    link_open_in_new_tab: PropTypes.bool.isRequired,
    node_id: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
}
